module.exports = __webpack_public_path__ + "img/shape3.78dc5ae6.svg";